import { Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SettlementsService } from 'src/app/services/settlements.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-modal-gas-meter-maintenance',
  template: `
    <ng-template #modalGasMeterMaintenance let-modal>
      <div class="modal-header">
        <h5 class="modal-title">Mantenimiento de medidor de gas</h5>
        <button type="button" (click)="dismiss()" data-dismiss="modal" aria-label="Close" class="btn btn-link text-dark">
          <fa-icon [icon]="icons.faTimes"></fa-icon>
        </button>
      </div>
      <div class="modal-body p-4">
        <form [formGroup]="meterForm" (ngSubmit)="onSubmit()">
          <div class="form-group required">
            <label for="consumption" class="form-label">Lectura previa al mantenimiento</label>
            <input type="number" formControlName="consumption" class="form-control" id="consumption" placeholder="">
          </div>
          <div class="form-group required mt-3">
            <label for="reason" class="form-label">Motivo del mantenimiento</label>
            <textarea formControlName="reason" class="form-control" id="reason" placeholder="" rows="3"></textarea>
          </div>
          <div class="form-group text-end mt-4">
            <button type="submit" class="btn btn-outline-primary rounded-3">Crear mantenimiento</button>
          </div>
        </form>
      </div>
    </ng-template>
  `,
  styleUrls: []
})
export class ModalGasMeterMaintenanceComponent {
  @Input() set meter(value: any) {
    if (this.meterForm.contains('gas_meter_id')) {
      this.meterForm.patchValue({
        gas_meter_id: value?.id ?? ''
      });
    }
  };
  @Output() updateDismiss: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('modalGasMeterMaintenance') modalGasMeterMaintenance !: ElementRef;

  private modalRef: NgbModalRef | undefined;
  meterForm: FormGroup = new FormGroup({});

  constructor(
    private store: SettlementsService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    public icons: IconsService,
    private modalService: NgbModal
  ) {
    this.initForm();
  }

  initForm() {
    this.meterForm = this.fb.group({
      id: [],
      consumption: [''],
      reason: [''],
      gas_meter_id: ['']
    });
  }

  onSubmit() {
    console.log('ngSubmit', this.meterForm.value);
    if (this.meterForm.invalid) {
      this.toastr.error('Formulario inválido.', 'Error');
      return;
    }

    this.store.createGasMeterMaintenance(this.meterForm.value).subscribe({
      next: (data: any) => {
        this.toastr.success('Mantenimiento se creó correctamente.', 'Éxito');
        this.dismiss();
      },
      error: (err: any) => {
        console.log(err);
        this.toastr.error(`Mantenimiento no pudo ser creado. \n ${err.error.exception}`, 'Error');
      }
    });
  }

  openModal(modalContent: TemplateRef<any>) {
    this.modalRef = this.modalService.open(modalContent);
  }

  dismiss() {
    if (this.modalRef) {
      this.updateDismiss.emit();
      this.modalRef.dismiss();
    }
  }

}
